import React from 'react';
import classNames from 'classnames/bind';
import { IconArrowsLeft, IconArrowsRight } from '@carnica/graphics';
import { Button } from '@carnica/ui-kit';
import styles from "./styles.pcss";
import { useCarouselNavigationButtons } from "../useCarouselNavigationButtons";
var cn = classNames.bind(styles);
var arrowMap = {
  next: IconArrowsRight,
  prev: IconArrowsLeft
};
export var CarouselArrow = function CarouselArrow(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'prev' : _ref$type,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'primary' : _ref$view;
  var isNext = type === 'next';
  var isPrev = type === 'prev';
  var _useCarouselNavigatio = useCarouselNavigationButtons(),
    isNextBtnEnable = _useCarouselNavigatio.isNextBtnEnable,
    isPrevBtnEnable = _useCarouselNavigatio.isPrevBtnEnable,
    handlePrevSlide = _useCarouselNavigatio.handlePrevSlide,
    handleNextSlide = _useCarouselNavigatio.handleNextSlide;
  var handleClick = function handleClick() {
    if (isNext) handleNextSlide();
    if (isPrev) handlePrevSlide();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('carousel-arrow', isPrev && 'arrow-prev', isNext && 'arrow-next', !isPrevBtnEnable && isPrev && 'hide', !isNextBtnEnable && isNext && 'hide'),
    "data-t-id": "CarouselNavigationButtons-CarouselArrow"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('arrow-button', isPrev && 'arrow-prev__button', isNext && 'arrow-next__button'),
    iconLeft: arrowMap[type],
    onClick: handleClick,
    onlyIcon: true,
    view: view
  }));
};